import { render, staticRenderFns } from "./MultiLineButton.vue?vue&type=template&id=2dec2f0c"
import script from "./MultiLineButton.vue?vue&type=script&lang=js"
export * from "./MultiLineButton.vue?vue&type=script&lang=js"
import style0 from "./MultiLineButton.vue?vue&type=style&index=0&id=2dec2f0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports